// import React, { useState } from 'react';
// import AddOpportunityModal from '../../components/referral/AddOpportunityModal.jsx';

// const App = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
  
//   const handleSubmit = (formData) => {
//     console.log('Form submitted:', formData);
//     // Handle form submission logic here
//   };

//   return (
//     <div>
//       <button onClick={() => setIsModalOpen(true)}>Add Opportunity</button>
      
//       <AddOpportunityModal 
//         isOpen={isModalOpen} 
//         onClose={() => setIsModalOpen(false)} 
//         onSubmit={handleSubmit} 
//       />
//     </div>
//   );
// };

// export default App;


// pages/referral/referral.js

// pages/referral/index.js
import AddOpportunityModal from '../../components/referral/AddOpportunityModal.jsx';

export default function ReferralPage() {
  return <AddOpportunityModal isOpen={true} onClose={() => window.history.back()} />;
}